import React from 'react';
import SearchMediaReportMaster from './RuleGroup/index';

const SearchDialog = ({handleDialog, searchShow, setRuleCode}) => {
  return (
    <>
      {searchShow ? (
        <SearchMediaReportMaster handleDialog={handleDialog} setRuleCode={setRuleCode} />
      ) : null}
    </>
  );
};

export default SearchDialog;
